<template>
  <v-container fluid class="elegant-container py-8">
    <v-row class="mb-6">
      <v-col cols="12">
        <h2 class="elegant-title">수강신청 안내 </h2>
        <p class="subtitle-1 grey--text text--darken-1 mt-4">
          3단계의 간단한 절차로 영어 실력 향상을 시작하세요
        </p>
      </v-col>   
      
      <v-col cols="12" sm="11" md="10" lg="9" class="mx-auto">
        <v-card class="elegant-card elevation-3">
          <v-card-text class="pa-2">
            <v-stepper v-model="e6" complete editable non-linear rounded class="register-stepper">
              <v-stepper-header class="register-header">
                <template v-for="n in 3">
                  <v-stepper-step
                    :key="'step-' + n"
                    :complete="e6 > n"
                    :step="n"
                    :class="{'active-step': e6 === n}"
                  >
                    <span class="step-title">{{ getStepTitle(n) }}</span>
                    <small class="step-subtitle">{{ getStepSubtitle(n) }}</small>
                  </v-stepper-step>
                  <v-divider
                    v-if="n !== 3"
                    :key="'div-' + n"
                  ></v-divider>
                </template>
              </v-stepper-header>
              
              <v-stepper-items>
                <v-stepper-content 
                  v-for="n in 3" 
                  :key="'content-' + n"
                  :step="n"
                  class="stepper-content"
                >
                  <v-fade-transition>
                    <div class="content-wrapper">
                      <div class="text-center my-2 image-container">
                        <v-img 
                          :class="['elegant-img', 'register-guide-img', 'mx-auto', {'active-image': e6 === n}]"
                          :src="`${app.cdnUrl}/website/guide/register_guide_${n}.png`" 
                          height="500px" 
                          width="300px" 
                          contain
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="primary"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>
                      
                      <div class="step-description text-center mb-2">
                        {{ getStepDescription(n) }}
                      </div>
                      
                      <v-divider class="elegant-divider mb-6"></v-divider>
                      
                      <v-row :class="{'justify-space-between': n !== 1, 'justify-end': n === 1}">
                        <v-col :cols="n === 1 ? 12 : 6" :class="{'text-right': n === 1}">
                          <v-btn
                            v-if="n !== 1"
                            class="elegant-btn outlined px-6"
                            @click="e6 = n - 1"
                            elevation="0"
                          >
                            <v-icon left>mdi-arrow-left</v-icon>
                            이전 단계
                          </v-btn>
                        </v-col>
                        <v-col :cols="n === 1 ? 12 : 6" class="text-right">
                          <v-btn
                            class="elegant-btn primary px-6"
                            @click="n === 3 ? (e6 = 1) : (e6 = n + 1)"
                            elevation="2"
                          >
                            <template v-if="n !== 3">
                              다음 단계
                              <v-icon right>mdi-arrow-right</v-icon>
                            </template>
                            <template v-else>
                              처음으로
                              <v-icon right>mdi-refresh</v-icon>
                            </template>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </v-fade-transition>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper> 
          </v-card-text>
        </v-card>
      </v-col> 
    </v-row>
    <v-row class="justify-center py-2">
      <v-col cols="8" md="4">
          <E_BtnTest ></E_BtnTest>
        </v-col>
      <!-- <div class="text-center mt-8">
        <E_BtnTest  ></E_BtnTest>

        <E_TestBtnSmall class="register-cta"></E_TestBtnSmall>
      </div> -->
    </v-row>
  </v-container>
</template>

<script>
import E_TestBtnSmall from "@/components/E_RegisterBtn";
import E_BtnTest from "@/components/E_TestBtn";

import {mapGetters} from "vuex";

export default {
  name: 'RegisterGuide',
  data: () => ({
    e6: 1,
  }),
  components: { E_TestBtnSmall, E_BtnTest},
  computed: {
    ...mapGetters(['app']),
  },
  methods: {
    getStepTitle(step) {
      const titles = {
        1: '기본 정보',
        2: '수업 설정',
        3: '결제 진행'
      }
      return titles[step]
    },
    getStepSubtitle(step) {
      const subtitles = {
        1: '고객 정보 및 일정',
        2: '주제, 방식, 시간',
        3: '확인 및 결제'
      }
      return subtitles[step]
    },
    getStepDescription(step) {
      const descriptions = {
        1: '고객님의 기본 정보와 선호하는 수업 일정을 입력해주세요.',
        2: '원하시는 수업 주제와 방식, 시간을 선택해주세요.',
        3: '수업료 확인 후 테스트 수업을 신청하거나 바로 결제를 진행하실 수 있습니다.'
      }
      return descriptions[step]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
@import "@/assets/scss/elegant-theme.scss"; 

.register-stepper {
  box-shadow: none !important;
  background-color: transparent !important;
  
  .register-header {
    box-shadow: none;
    border: none;
    height: auto;
    padding: 0px 0 12px;
    
    .v-stepper__step {
      padding: 0px 12px;
      
      &.active-step {
        .step-title {
          color: var(--v-primary-base);
          font-weight: 600;
        }
      }
      
      .step-title {
        font-size: 1.1rem;
        margin-bottom: 4px;
        transition: color 0.3s ease;
      }
      
      .step-subtitle {
        font-size: 0.85rem;
        color: rgba(0, 0, 0, 0.6);
      }
      
      .v-stepper__step__step {
        margin-bottom: 12px;
        background-color: var(--v-primary-base) !important;
        font-weight: 600;
        transition: transform 0.3s ease;
        
        &.primary {
          transform: scale(1.2);
        }
      }
    }
    
    .v-divider {
      margin: 12px -8px;
      border-width: 2px;
      opacity: 0.7;
    }
  }
}

.stepper-content {
  padding: 0px 4px;
  
  .content-wrapper {
    max-width: 800px;
    margin: 0 auto;
  }
  
  .image-container {
    position: relative;
    padding: 4px;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 280px;
      height: 100%;
      background: linear-gradient(180deg, rgba(var(--v-primary-base), 0.1) 0%, rgba(var(--v-primary-base), 0) 100%);
      border-radius: 20px;
      z-index: 0;
    }
  }
}

.register-guide-img {
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  
  &.active-image {
    transform: translateY(-8px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  }
}

.step-description {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.7);
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

.register-cta {
  transform: scale(1);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
}

// Dark mode adjustments
.theme--dark {
  .title-underline {
    background: linear-gradient(90deg, var(--v-primary-base) 0%, var(--v-primary-darken2) 100%);
  }
  
  .step-subtitle {
    color: rgba(255, 255, 255, 0.6) !important;
  }
  
  .step-description {
    color: rgba(255, 255, 255, 0.7);
  }
  
  .image-container::before {
    background: linear-gradient(180deg, rgba(var(--v-primary-base), 0.15) 0%, rgba(var(--v-primary-base), 0) 100%);
  }
}
</style>